import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import type { Playlist } from 'types/playlist'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { savePlaylistMetadata } from '@disco/state-management/actions/ServerActions'
import { getPlaylist } from '@disco/state-management/selectors/playlists'
import ModalDialog from 'components/ui/modal-dialog'
import TextField from 'components/ui/text-field'
import type { RootState } from 'store/configureStore'

interface OwnProps {
  params: {
    playlistId: string
  }
  navigate: NavigateFunction
}

function mapStateToProps(state: RootState, props: OwnProps) {
  return {
    playlist: getPlaylist(state, {
      id: parseInt(props.params.playlistId, 10),
    }),
    saving: state.server.saving,
  }
}

const mapDispatchToProps = {
  sendMixpanelEvent,
  savePlaylistMetadata,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>
type Props = PropsFromRedux & OwnProps
type State = {
  name: string
}

class EditMetadata extends React.Component<Props, State> {
  state = {
    name: this.props.playlist.name,
  }
  _handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      name: e.target.value,
    })
  }
  _handleSubmit = () => {
    this.props
      .savePlaylistMetadata(this.props.playlist, {
        name: this.state.name,
      })
      .then(() => {
        this.props.sendMixpanelEvent('Rename playlist')

        this._closeModal()
      })
  }
  _closeModal = () => this.props.navigate('/')

  render() {
    return (
      <ModalDialog
        title="Rename playlist"
        primaryAction={{
          caption: 'Rename',
          progressCaption: 'Renaming',
          progressIndicator: this.props.saving,
          onClick: this._handleSubmit,
        }}
        onCancel={this._closeModal}
      >
        <TextField
          autoFocus
          label="Name"
          value={this.state.name}
          onChange={this._handleNameChange}
        />
      </ModalDialog>
    )
  }
}

const ConnectedEditMetadata = connector(EditMetadata)

function EditMetadataWithNavigation(props: any) {
  const navigate = useNavigate()
  const params = useParams<{ playlistId: string }>()
  return (
    <ConnectedEditMetadata
      {...props}
      navigate={navigate}
      params={params as { playlistId: string }}
    />
  )
}

export default EditMetadataWithNavigation
